import { render, staticRenderFns } from "./manageCustom.vue?vue&type=template&id=50524b8c&scoped=true&"
import script from "./manageCustom.vue?vue&type=script&lang=js&"
export * from "./manageCustom.vue?vue&type=script&lang=js&"
import style0 from "./manageCustom.vue?vue&type=style&index=0&id=50524b8c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50524b8c",
  null
  
)

export default component.exports